import { Outlet, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuthStore } from '@/store/authStore';
import { BrandingFooter } from '@/components';

export function PublicLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const role = useAuthStore((state) => state.role);

  // Redirect authenticated users to their portal
  if (isAuthenticated) {
    if (role === 'teacher') return <Navigate to="/teacher" replace />;
    if (role === 'super_admin') return <Navigate to="/super-admin/schools" replace />;
    return <Navigate to="/app/dashboard" replace />;
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Outlet />
      </Box>
      <BrandingFooter />
    </Box>
  );
}
